export enum settingsPaths {
  categoriesThematic = '/thematic_categories',
  categoriesAge = '/age_categories',
}
